import { render, staticRenderFns } from "./ReminderItem.vue?vue&type=template&id=53aefce6&scoped=true&lang=pug&"
import script from "./ReminderItem.vue?vue&type=script&lang=js&"
export * from "./ReminderItem.vue?vue&type=script&lang=js&"
import style0 from "./ReminderItem.vue?vue&type=style&index=0&id=53aefce6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53aefce6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
